import React from "react";

import Grid from "components/Grid";

import InfoItem from "../components/InfoItem";

const BtcInfo = ({ btc }) => {
  if (!btc) return null;

  return (
    <Grid gutter={[24, 24]} columns={2}>
      <InfoItem name="BTC ID" value={btc.id} />
      <InfoItem name="Connected Doors" value={btc.connected_doors} />
      <InfoItem name="Model" value={btc.model} />
      <InfoItem name="Location" value={btc.location_name} />
      <InfoItem name="LTR" value={btc.is_ltr ? "Yes" : "No"} />
      <InfoItem name="Active" value={btc.is_active ? "Yes" : "No"} />
      <InfoItem name="Notes" value={btc.notes} />
      <InfoItem name="Default Message" value={btc.default_msg} />
      <InfoItem name="Additional Params" value={btc.additional_params} /> {}
      <InfoItem name="Hardware ID" value={btc.hw_id} />
    </Grid>
  );
};

export default BtcInfo;